/* eslint-disable no-undef */
/*global google*/
/*eslint comma-dangle: 0 */
import Swiper from 'swiper';

export default {
  init() {
    const mapStyle = [{
        'featureType': 'all',
        'elementType': 'geometry',
        'stylers': [{
            'color': '#94bfcf'
          },
          {
            'saturation': '-14'
          },
          {
            'lightness': '17'
          }
        ]
      },
      {
        'featureType': 'all',
        'elementType': 'labels.text.fill',
        'stylers': [{
            'gamma': 0.01
          },
          {
            'lightness': 20
          }
        ]
      },
      {
        'featureType': 'all',
        'elementType': 'labels.text.stroke',
        'stylers': [{
            'saturation': -31
          },
          {
            'lightness': -33
          },
          {
            'weight': 2
          },
          {
            'gamma': 0.8
          }
        ]
      },
      {
        'featureType': 'all',
        'elementType': 'labels.icon',
        'stylers': [{
            'visibility': 'off'
          },
          {
            'saturation': '73'
          },
          {
            'color': '#94bfcf'
          }
        ]
      },
      {
        'featureType': 'administrative.country',
        'elementType': 'geometry.fill',
        'stylers': [{
            'visibility': 'on'
          },
          {
            'hue': '#00ff71'
          }
        ]
      },
      {
        'featureType': 'landscape',
        'elementType': 'geometry',
        'stylers': [{
            'lightness': 30
          },
          {
            'saturation': 30
          }
        ]
      },
      {
        'featureType': 'poi',
        'elementType': 'geometry',
        'stylers': [{
          'saturation': 20
        }]
      },
      {
        'featureType': 'poi.park',
        'elementType': 'geometry',
        'stylers': [{
            'lightness': 20
          },
          {
            'saturation': -20
          }
        ]
      },
      {
        'featureType': 'road',
        'elementType': 'geometry',
        'stylers': [{
            'lightness': 10
          },
          {
            'saturation': -30
          }
        ]
      },
      {
        'featureType': 'road',
        'elementType': 'geometry.stroke',
        'stylers': [{
            'saturation': 25
          },
          {
            'lightness': 25
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'all',
        'stylers': [{
          'lightness': -20
        }]
      }
    ];

    // JavaScript to be fired on all pages
    $('ul.navbar-nav li.dropdown').hover(
      function() {
        $(this).find('.dropdown-menu').stop(true, true).fadeIn(500);
      },
      function() {
        $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
      }
    );

    if ($('#swiper-services').length > 0) {
      new Swiper('#swiper-services', {
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        centeredSlides: true,
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          1900: {
            slidesPerView: 5,
            spaceBetween: 40,
          },
        },
      });
    }

    if ($('#swiper-network').length > 0) {
      new Swiper('#swiper-network', {
        slidesPerView: 4,
        spaceBetween: 10,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        loop: true,
        breakpoints: {
          1024: {
            slidesPerView: 6,
            spaceBetween: 40,
          }
        },
      });
    }

    if ($('ul#services-list').length > 0) {
      $('ul#services-list > li').click(function() {
        let clickedId = $(this).data('id');
        $('#services-list li.active').removeClass('active');
        $(this).addClass('active');

        $('#services-content-wrapper .content-div').removeClass('active');
        $('#services-content-wrapper div[data-id="' + clickedId + '"]').addClass('active');

        $('#services-image-wrapper img').removeClass('active');
        let image = $('#services-image-wrapper img[data-id="' + clickedId + '"]');
        image.addClass('active');

        $('#bg-switcher')
          .animate({
            opacity: 0,
          }, function() {
            $(this).css('background-image', 'url(' + image.attr('src') + ')')
              .animate({
                opacity: 1,
              }, 'slow')
          })
      })
      startServices();
      $(window).on('resize', resizeServiceWrapper);
    }

    function startServices() {
      $('ul#services-list > li').first().trigger('click')
      setTimeout(resizeServiceWrapper, 50);
    }

    function resizeServiceWrapper() {
      let maxHeight = 0;
      $('#services-image-wrapper img').each(function() {
        if (this.scrollHeight > maxHeight) maxHeight = this.scrollHeight;
      })
      $('.service-wrapper').css('min-height', maxHeight + 100);
      $('.menu-wrapper').css('min-height', maxHeight + 100);
    }

    if ($('*[data-counter="true"]')) {
      checkCounters();
      $(window).on('scroll', checkCounters);
    }

    function checkCounters() {
      $('*[data-counter="true"]:not([data-animated="1"])').each(function() {
        if (checkInViewPort(this)) {
          count(this);
        }
      });
    }

    function checkInViewPort(element) {
      var top_of_element = $(element).offset().top;
      var bottom_of_element = $(element).offset().top + $(element).outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      var top_of_screen = $(window).scrollTop();

      if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
        return true;
      }
      return false;
    }

    function count(element) {
      $(element).prop('Counter', 0).animate({
        Counter: $(element).data('number'),
      }, {
        duration: 1000,
        easing: 'swing',
        step: function(now) {
          $(element).text(pointSeparateNumber(Math.floor(now)));
        },
        complete: function(now) {
          $(element).text(pointSeparateNumber(now));
        }
      });
      $(element).attr('data-animated', '1');
    }

    function pointSeparateNumber(val) {
      while (/(\d+)(\d{3})/.test(val.toString())) {
        val = val.toString().replace(/(\d+)(\d{3})/, '$1' + '.' + '$2');
      }
      return val;
    }

    if ($('*[data-animated-circle="true"]')) {
      setDashData();
      checkCircles();
      $(window).on('scroll', checkCircles);
    }

    function checkCircles() {
      $('*[data-animated-circle="true"]:not([data-animated="1"])').each(function() {
        if (checkInViewPort(this)) {
          animateCircle(this);
        }
      });
    }

    function setDashData() {
      $('*[data-animated-circle="true"]').each(function() {
        var radius = this.r.baseVal.value;
        var circumference = radius * 2 * Math.PI;

        this.style.strokeDasharray = circumference;
        this.style.strokeDashoffset = circumference;
        $(this).attr('data-circumference', circumference);
      });
    }

    function animateCircle(element) {
      let percent = (100 * $(element).data('number')) / $(element).data('total');
      let circumference = $(element).attr('data-circumference');

      const offset = circumference - Math.ceil(percent) / 100 * circumference;
      element.style.strokeDashoffset = offset;
      $(element).attr('data-animated', 1);
    }

    function newMap($el) {
      var $markers = $el.find('.marker');

      var args = {
        zoom: 16,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        styles: mapStyle
      };

      var map = new google.maps.Map($el[0], args);
      map.markers = [];
      $markers.each(function() {
        addMarker($(this), map);
      });

      centerMap(map);
      return map;

    }

    function addMarker($marker, map) {
      var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

      var marker = new google.maps.Marker({
        position: latlng,
        map: map,
      });
      map.markers.push(marker);

      if ($marker.html()) {
        var infowindow = new google.maps.InfoWindow({
          content: $marker.html(),
        });

        google.maps.event.addListener(marker, 'click', function() {
          infowindow.open(map, marker);
        });
      }

    }

    function centerMap(map) {
      var bounds = new google.maps.LatLngBounds();
      $.each(map.markers, function(i, marker) {
        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
        bounds.extend(latlng);
      });

      if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());
        map.setZoom(16);
      } else {
        map.fitBounds(bounds);
      }
    }

    if ($('.map-canvas').length > 0) {
      newMap($('.map-canvas'));
    }

    if ($('*[data-toggler="true"]')) {
      $('#subvention-wrapper').on('click', '*[data-toggler="true"]', function(){
        let target = '#' + $(this).data('target');
        $(target).toggleClass(['active', 'p-3', 'mt-3']);
        let parentTarget = '#' + $(this).data('parent');
        $(parentTarget)[0].scrollIntoView({behavior: 'smooth', inline: 'nearest'});
      });
    }

    function loadSubventions(page) {
      let filters = [];
      let getParams = [];
      filters['action'] = 'get_filtered_subventions';
      filters['pag'] = page;
      getParams['pag'] = page;

      let search = $('#search-term').val();
      if (search) {
        filters['search'] = search;
        getParams['search'] = search;
      }

      let mainDiv = document.getElementById('subventions');
      let customType = $(mainDiv).data('customType');
      filters['customType'] = customType;

      $('*[data-subvention-filter="true"]:checked').each(function() {
        if (filters.hasOwnProperty($(this).data('type'))) {
          filters[$(this).data('type')] = filters[$(this).data('type')] + '|' + $(this).attr('id');
          getParams[$(this).data('url-type')] = getParams[$(this).data('url-type')] + '|' + $(this).attr('id');
        } else {
          filters[$(this).data('type')] = $(this).attr('id');
          getParams[$(this).data('url-type')] = $(this).attr('id');
        }
      });

      const urlParts = Object.entries(getParams).map(([k, v]) => {
          return `${k}=${v}`;
      });

      history.pushState(undefined, undefined, '?' + urlParts.join('&'));

      $('#subvention-wrapper').empty();
      $('#loader').toggleClass('d-none');

      let filtersData = Object.assign({}, filters);
      $.ajax({
        type: 'POST',
        url: azaro.ajax_url,
        data: filtersData,
        success: function (result) {
          $('#subvention-wrapper').html(result);
          $('#loader').toggleClass('d-none');
        },
      });
    }

    function loadSubventionPdf(id) {
      $('#loader-wrapper').toggleClass('active');
      $.ajax({
        type: 'POST',
        url: azaro.ajax_url,
        data: {
          id: id,
          action: 'get_subvention_pdf'
        },
        success: function (result) {
          $('#loader-wrapper').toggleClass('active');
          var url = '/wp-content/uploads/pdfs/' + result;
          downloadURI(url, result);
        },
      });
    }

    function downloadURI(uri, name) {
      let link = document.createElement('a');
      link.download = name;
      link.href = uri;
      link.click();
    }

    if ($('*[data-subvention-pdf="true"]')) {
      $('#subvention-wrapper').on('click', '*[data-subvention-pdf="true"]', function(){
        let id = $(this).data('id');
        loadSubventionPdf(id);
      });
    }

    if ($('*[data-subvention-filter="true"]')) {
      $('*[data-subvention-filter="true"]').click(function() {
        loadSubventions(1);
      });
    }

    if ($('*[data-paginator="true"]')) {
      $('#subvention-wrapper').on('click', '*[data-paginator="true"]', function(){
        let page = $(this).data('page');
        loadSubventions(page);
      });
    }

    if ($('#search-button')) {
      $('#subventions').on('click', '#search-button', function(){
        loadSubventions(1);
      });
      $('#search-term').on('keyup', function(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          $('#search-button').trigger('click');
        }
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js